module.exports = __webpack_public_path__ + "9fd5e17501fe0a4159e8a1d429603d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail.png
// module id = 586
// module chunks = 0